import axios from 'axios'

export default{
    namespaced: true,
    state: {
        attendanceDates: []
    },
    getters: {
        getAttendanceDates(state){
            return state.attendanceDates
        }
    },
    mutations: {
        setAttendanceDates(state, value){
            state.attendanceDates = value
        }
    },
    actions: {
        getAttendanceData({ getters, rootGetters }){
            const url = '/api/student-attendance'
            return axios.get(url, {
                params: {
                    student_id: rootGetters['auth/getStudentRecord'].id,
                    attendance_dates: getters.getAttendanceDates
                }
            })
        },

        getValidAttendanceDates(){
            const url = '/api/student-attendance/valid-dates'
            return axios.get(url)
        }
    }
}